/** @format */

import type {SensorCategoriesBunchType} from 'types';

import {CategoriesData} from 'pages/Home/Main/Project/components/Issues/model';

import settingsImg from '../../images/toggle_on.svg';
import qualityImg from '../../images/show_chart.svg';
import targetingImg from '../../images/radar.svg';
import feedsImg from '../../images/format_list_bulleted.svg';
import budgetImg from '../../images/paid.svg';
import kpiImg from '../../images/kpi_icon.svg';

const categoryIcons: Record<SensorCategoriesBunchType, string> = {
  campaign_settings: settingsImg,
  ads_quality: qualityImg,
  targeting_semantic_kernel: targetingImg,
  feeds: feedsImg,
  budget: budgetImg,
  kpi: kpiImg,
};

export interface SensorCategory {
  id: string;
  category: string;
  icon: string;
}

export interface SensorCategoryMap {
  [key: string]: SensorCategory;
}

export const mapSensorsToCategory = (categories: CategoriesData[]): SensorCategoryMap => {
  return categories.reduce((acc, category) => {
    category.sensors.forEach(sensor => {
      acc[sensor] = {
        id: category.name,
        category: category.title,
        icon: categoryIcons[category.name],
      };
    });
    return acc;
  }, {} as SensorCategoryMap);
};
